import mod from "-!./Reservations.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./Reservations.js?vue&type=script&lang=js&external"